import React, { useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import { api } from '../api';
import { fetchToken } from '../auth/Token';
import { Box, Typography, Link, Divider, Button } from '@mui/material';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { toast } from 'sonner';

export default function CreateLoans(props) {
    const [loan, setAllLoan] = useState([]);
    const [open, setOpen] = React.useState(false);
    const handleClose = () => {
      setOpen(false);
    };
    const handleOpen = () => {
      setOpen(true);
    };

    
    const Item = styled(Paper)(({ theme }) => ({
        backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
        ...theme.typography.body2,
        padding: theme.spacing(1),
        textAlign: 'center',
        color: theme.palette.text.secondary,
      }));
      const allLoansAccounts = () => {
        const savedLoanAccounts = localStorage.getItem("loanAccountsData");
      
        if (savedLoanAccounts) {
          setAllLoan(JSON.parse(savedLoanAccounts));
        }
      
        try {
          api.get("/account/loan/hh", {
            headers: {
              Authorization: 'Bearer ' + fetchToken(),
            },
          }).then(function (response) {
            const loanData = response.data;
            localStorage.setItem("loanAccountsData", JSON.stringify(loanData));
            setAllLoan(loanData);
          }).catch(function (error) {
            console.log("Here is the error: " + error);
          });
        } catch (error) {
          console.log("Error occurred during the fetch: " + error);
        }
      };
      
      useEffect(() => {
        
          allLoansAccounts();
      },[])

      const handleSave = (id) =>{
        handleOpen()
        const isAccountExist = props.accounts.some((item) => item.loan_id === id);
        const iinfo = {
          'loan_id': id,
          'association_member_id': props.Psb,
          'member_id': props.member_id
        }
        if(isAccountExist){
          handleClose()
          toast.error("Account already exist")
        }else{
          try {
            api.post('/account/memberloan',iinfo, {
              headers: {
                Authorization: 'Bearer ' + fetchToken()
              }
            }).then(function (response){
              toast.success(response.data)
              props.fetchAccounts();
              allLoansAccounts();
            }).finally(function (){
              handleClose(false)
            })
          } catch (error) {
            console.log("Here is the error"+error)
          }
      }
      };

      // console.log(loan)

  return (
    <div>
        <Item>
            <Box>
              <Typography variant='h3'>Select Loans Account to Open</Typography>
              <Divider>||--||</Divider>
            {loan.map((savingItem, index) => (
                      <Link
                          sx={{ display:'flex' }}
                          key={index}
                          variant="h6"
                          underline="none"
                          component='button'
                          color="inherit"
                          onClick={() => handleSave(savingItem.id)}
                      >
                        
                          
                        <Typography variant='h5' sx={{ fontWeight:'600', color:'darkblue'}}>
                            {savingItem.account_name}: (Application fee: {savingItem.application_fee}%) | (Processing fee: {savingItem.proccessing_fee}%)
                        </Typography>
                          
                      </Link>
                      
                  ))}
            </Box>
            <Button variant='outlined' onClick={()=>props.setOpen_acc()}>Close</Button>
        </Item>
          <Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={open}
            onClick={handleClose}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
    </div>
  )
}
